<div class="innerBanner" style="background-image: url('../../../assets/images/banner-accommodation.avif')">
  <div class="bannerText">
    <h1>{{ 'Email Verification' | translate }}</h1>
  </div>
</div>
<div class="container mt-2">
  <p *ngIf="!verifiationFailed">Email Address is Verified Successfully Please log in to enjoy the services</p>
  <p *ngIf="verifiationFailed">Not Verified</p>
</div>
